export default {
  namespaced: true,

  getters: {
    elements: (state, getters, rootState, rootGetters) => (element, parentModule) => {
      if (parentModule) {
        let rows = rootGetters['componentSectionModule/elements'](element, parentModule).rows
        return Object.prototype.hasOwnProperty.call(element, 'componentRow') ? rows[element.componentRow] : rows
      }
      let rows = rootGetters['componentSectionModule/elements'](element).rows
      return Object.prototype.hasOwnProperty.call(element, 'componentRow') ? rows[element.componentRow] : rows
    },
    name: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).name,
    index: (state, getters) => (element, id, parentModule) => getters.elements(element, parentModule).findIndex(component => component.id == id),
    id: (state, getters) => (element, id = 'id', parentModule) => getters.elements(element, parentModule)[id],
    classes: (state, getters) => (element, classes = 'classes', parentModule) => getters.elements(element, parentModule)[classes],
    styles: (state, getters) => (element, styles = 'styles', parentModule) => getters.elements(element, parentModule)[styles],
    assets: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).assets,
    properties: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).properties,
    background: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).background,
  },

  actions: {
    removeFromArray({commit}, payload) {
      payload = {...payload, module: 'componentRowModule'}
      commit('actionsModule/removeFromArray', payload, {root: true})
    },
    addToArray({commit}, payload) {
      payload = {...payload, module: 'componentRowModule'}
      commit('actionsModule/addToArray', payload, {root: true})
    },
    addToObject({commit}, payload) {
      payload = {...payload, module: 'componentRowModule'}
      commit('actionsModule/addToObject', payload, {root: true})
    },
    updateOrder({commit}, payload) {
      payload = {...payload, module: 'componentRowModule'}
      commit('actionsModule/updateElementsOrder', payload, {root: true})
    },
  }
}